<template>
  <modal wrapperClasses="passcode">
    <div slot="body" class="modal-content">
      <div>
        enter your log in code below to proceed
      </div>
      <passcode-input
        :length-limitation="4"
        :passcode.sync="passcode"
        autocomplete="one-time-code" />
      <div v-if="error" class="error">{{ error }}</div>
    </div>
    <div v-if="!showResend" slot="action" class="modal-click-action">
      <button @click="clickedResend(1.5 * 60 * 1000)" :disabled="logInCodeHasBeenSent" :class="{ disabled: logInCodeHasBeenSent }">{{ sendLogInCodeLabel }}</button>
    </div>
    <div v-if="showResend" slot="footer" class="modal-footer">
      <div>didn't get the code?</div>
      <div @click="clickedResend(10 * 60 * 1000)" v-if="!hasBeenResent" class="link">resend</div>
      <div v-if="hasBeenResent">thank you for your request. you should receive your log in code within a few minutes</div>
    </div>
  </modal>
</template>

<script>
  import Modal from '../../components/shared/Modal'
  import { passcodeAPI } from "../../services/api/passcode"
  import PasscodeInput from '../../components/shared/PasscodeInput'

  export default {
    props: {
      memberAccessCode: Number
    },

    name: 'EasyCodeFlowModal',

    data() {
      return {
        error: '',
        hasBeenResent: false,
        logInCodeHasBeenSent: false,
        passcode: '',
        showResend: false
      }
    },

    components: {
      Modal,
      PasscodeInput
    },

    computed: {
      encodedSecureLinkId(){
        return this.$route.params.id
      },

      sendLogInCodeLabel(){
        return !this.logInCodeHasBeenSent ? "send me my log in code" : "sending log in code now"
      }
    },

    methods: {
      submitLogInCode(){
        if(!this.passcode) return this.showInvalidLogInCodeErr()
        return  passcodeAPI.getCheckLogInCode(
                  this.encodedSecureLinkId,
                  this.passcode
                )
                .then(data => {
                  if(!!data.redirect_url){
                    location.replace(data.redirect_url)
                  }else {
                    this.$router.push({
                      name: 'Stashboard',
                      params: {
                        id: this.encodedSecureLinkId,
                        anyLinks: data.any_link_extensions,
                        appStoreUrl: data.app_store_url,
                        content: data.sms_content,
                        extensionType: data.type,
                        googlePlayUrl: data.google_play_url,
                        merchantName: data.merchant_name,
                        merchantWebsiteUrl: data.website,
                        stashboardHeaders: data.stashboard_headers,
                        urlButton: data.url,
                        urlImage: data.mms_cdn_link,
                        urlLogo: data.merchant_logo?.url,
                      }
                    })
                  }
                })
                .catch(error => {
                  this.showInvalidLogInCodeErr()
                  setTimeout(() => {
                    this.passcode = ''
                  }, 1000);
                })
      },

      clearError(){
        return this.error = ''
      },

      clickedResend(duration){
        this.logInCodeHasBeenSent = true;
        if(this.showResend) this.hasBeenResent = true;
        // We show the button "resend" after the duration expires
        setTimeout(() => {
          if(this.showResend) this.hasBeenResent = !this.hasBeenResent
          this.showResend = true
        }, duration);
        this.sendLogInCode();
      },

      sendLogInCode(){
        return passcodeAPI.postSendLogInCode(this.encodedSecureLinkId).then(data => this.$emit('update:memberAccessCode', data.id));
      },

      showInvalidLogInCodeErr(){
        this.error = 'must enter valid code';
      }
    },

    watch: {
      passcode(value){
        if(value.length === 4) this.submitLogInCode()
      }
    }
  }

</script>
